import { CooperBotState } from '@pages/cooper-bot/store/states/cooper-bot.state';
import { CooperBotActionsSchemasState } from '@pages/cooper-bot/store/states/cooper-bot-actions-schemas.state';
import { CooperBotActionsState } from '@pages/cooper-bot/store/states/cooper-bot-actions.state';
import { CooperBotTriggersState } from '@pages/cooper-bot/store/states/cooper-bot-triggers.state';
import { CooperBotActionUiCallbacksState } from '@pages/cooper-bot/store/states/cooper-bot-action-ui-callbacks.state';
import { CooperBotTriggersSchemaState } from '@pages/cooper-bot/store/states/cooper-bot-triggers-schema.state';
import { CooperBotTriggerUiCallbacksState } from '@pages/cooper-bot/store/states/cooper-bot-trigger-ui-callbacks.state';
import { CooperBotBlueprintsState } from '@pages/cooper-bot/store/states/cooper-bot-blueprints.state';
import { CooperBotTriggerModuleInstancesState } from '@pages/cooper-bot/store/states/cooper-bot-trigger-module-instances.state';
import { CooperBotActionModuleInstancesState } from '@pages/cooper-bot/store/states/cooper-bot-action-module-instances.state';

export const cooperBotState = [
  CooperBotState,
  CooperBotActionsSchemasState,
  CooperBotActionsState,
  CooperBotTriggersState,
  CooperBotActionUiCallbacksState,
  CooperBotTriggerUiCallbacksState,
  CooperBotTriggersSchemaState,
  CooperBotBlueprintsState,
  CooperBotTriggerModuleInstancesState,
  CooperBotActionModuleInstancesState,
];
